'use strict';

class DeletableInvoiceList {
  constructor($location, $filter, deletableInvoiceService, Notification) {
    this.$location = $location;
    this.$filter = $filter;
    this.deletableInvoiceService = deletableInvoiceService;
    this.Notification = Notification;
  }

  $onInit() {
    this.documents = [];
    this.total = 0;
    this.title = 'Regninger som kan slettes';

    // sorting
    this.predicate = 'number';
    this.reverse = true;

    this.load();
  }

  order(predicate) {
    this.reverse = this.predicate === predicate ? !this.reverse : false;
    this.predicate = predicate;
  }

  load() {
    this.deletableInvoiceService.list()
      .then((resp) => {
        if (resp.data && resp.status !== 204) {
          let total = 0;

          resp.data.forEach((item) => {
            if (this.$filter('urlParser')(item._links.self.uri, 1) === 'drafts') {
              item.isDraft = true;
            }

            total += item.total;
            return item;
          }, this);

          this.total = total;
          this.documents = resp.data;
        }
        else {
          this.documents = [];
          this.total = 0;
        }
      });
  }

  delete(invoiceNumber) {
    this.deletableInvoiceService.delete(invoiceNumber)
      .then(() => {
        this.load();
      })
      .catch((err) => {
        this.Notification.error(err.data.endUserMessage);
      });
  }

  deleteDeletableInvoices() {
    this.deletableInvoiceService.deleteDeletableInvoices()
      .then(() => {
        this.load();
      })
      .catch((err) => {
        this.Notification.error(err.data.endUserMessage);
      });
  }
}

DeletableInvoiceList.$inject = ['$location', '$filter', 'deletableInvoiceService', 'Notification'];

const deletableInvoiceList = {
  controller: DeletableInvoiceList,
  template: `
    <h2>{{ $ctrl.title }} <small>({{ $ctrl.documents.length }} stk)</small></h2>
    <p>Her vises gamle regninger som ikke lenger kreves oppbevart i henhold til Bokføringsloven.</p>
    <p>Trykk p&aring; fakturanummeret for &aring; se på regningen, trykk p&aring; mottager for &aring; redigere mottageren.</p>
    <table class="responsive">
      <thead>
        <tr>
          <th ng-click="$ctrl.order('number')" ng-class="{ sortorder: $ctrl.predicate == 'number', reverse: $ctrl.reverse }">#</th>
          <th ng-click="$ctrl.order('description')" ng-class="{ sortorder: $ctrl.predicate == 'description', reverse: $ctrl.reverse }">Type</th>
          <th>Dato</th>
          <th>Forfallsdato</th>
          <th ng-click="$ctrl.order('customerNumber')" ng-class="{ sortorder: $ctrl.predicate == 'customerNumber', reverse: $ctrl.reverse }">Kundenummer</th>
          <th ng-click="$ctrl.order('recipientName')" ng-class="{ sortorder: $ctrl.predicate == 'recipientName', reverse: $ctrl.reverse }">Mottager</th>
          <th ng-click="$ctrl.order('orderNumber')" ng-class="{ sortorder: $ctrl.predicate == 'orderNumber', reverse: $ctrl.reverse }">Ordrereferanse</th>
          <th>Bel&oslash;p</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.documents | orderBy:$ctrl.predicate:$ctrl.reverse track by $index">
          <td>
            <!-- Domestic -->
            <a ng-if="item.description === 'Faktura' && !item.isDraft" href="#/regning/{{ item.number }}">{{ item.number }}</a>
            <a ng-if="item.description === 'Faktura' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1" href="#/regning/kladd/{{ item.number }}">Kladd</a>

            <a ng-if="item.description === 'Kreditnota' && !item.isDraft" href="#/kreditnota/{{ item.number }}">{{ item.number }}</a>
            <a ng-if="item.description === 'Kreditnota' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1" href="#/kreditnota/kladd/{{ item.number }}">Kladd</a>

            <!-- International -->
            <a ng-if="item.description === 'Faktura' && item.isDraft && item._links.self.uri.indexOf('international=true') !== -1" href="#/regning/kladd/engelsk/{{ item.number }}">Kladd</a>
            <a ng-if="item.description === 'Kreditnota' && item.isDraft && item._links.self.uri.indexOf('international=true') !== -1" href="#/kreditnota/kladd/engelsk/{{ item.number }}">Kladd</a>
          </td>
          <td>{{ item.description }}</td>
          <td>{{ item.date | dateFormat }}</td>
          <td>{{ item.dueDate | dateFormat }}</td>
          <td>{{ item.customerNumber }}</td>
          <td><a href="#/kunde/{{ item._links.recipient.uri | urlParser:1 }}">{{ item.recipientName }}</a></td>
          <td>{{ item.orderNumber }}</td>
          <td class="nowrap right-align">{{ item.total | crowns }}</td>
          <td class="right-align">
            <a ng-click="$ctrl.delete(item.number)" role="button" class="button small alert"><i class="fa fa-trash"></i> Slett</a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="7"></th>
          <th class="nowrap right-align">{{ $ctrl.total | crowns }}</th>
          <th class="right-align">
            <a ng-click="$ctrl.deleteDeletableInvoices()" role="button" class="button small alert"><i class="fa fa-trash"></i> Slett alle</a>
          </th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('deletableInvoiceList', deletableInvoiceList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kan-slettes', {
        title: 'Regninger som kan slettes',
        template: '<deletable-invoice-list />',
        secure: true
      });
  });
